// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"247":"178b5171","435":"b02407e0","538":"178b5171","619":"f66b8659","671":"178b5171","916":"178b5171"}[chunkId] + ".chunk.css";
};